import { css } from 'styled-components';

const variables = css`
  :root {
    --dark-navy: #08080c;
    --navy: #12121a;
    --light-navy: #1a1a24;
    --lightest-navy: #252533;
    --navy-shadow: rgba(0, 0, 0, 0.7);
    --dark-slate: #6b7280;
    --slate: #9ca3af;
    --light-slate: #d1d5db;
    --lightest-slate: #f3f4f6;
    --white: #ffffff;
    --green: #ff2a2a;
    --green-tint: rgba(255, 42, 42, 0.1);
    --pink: #ff4d4d;
    --blue: #1d4ed8;

    --gradient: linear-gradient(135deg, #ff2a2a, #12121a);
    --gradient-text: linear-gradient(135deg, #ffffff, #9ca3af);

    --font-sans: 'Outfit', -apple-system, system-ui, sans-serif;
    --font-mono: 'Space Grotesk', 'SF Mono', 'Fira Code', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 6px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
